import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT } from '../../data/siteContent';
import Icon from './Icon';

/**
 * Always-available conversion shortcuts.
 * Desktop: floating pill + round WhatsApp / call buttons (bottom-left).
 * Mobile:  sticky bottom action bar (Call · WhatsApp · Free Quote).
 */
function FloatingContact() {
  return (
    <>
      <div className="fc-desktop">
        <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="fc-round fc-round--wa" aria-label="Chat on WhatsApp">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.95L2 22l5.2-1.5A9.9 9.9 0 1 0 12.04 2Zm5.8 14.02c-.25.7-1.45 1.33-2 1.4-.52.07-1.17.1-1.9-.12a17 17 0 0 1-1.72-.64c-3.02-1.3-5-4.34-5.15-4.54-.15-.2-1.23-1.64-1.23-3.13s.78-2.22 1.06-2.52c.28-.3.6-.38.8-.38h.58c.19 0 .43-.07.66.5.25.6.85 2.07.92 2.22.08.15.13.33.03.52-.1.2-.15.32-.3.5-.15.17-.31.38-.44.51-.15.15-.3.3-.13.6.17.3.77 1.27 1.65 2.05 1.13 1 2.09 1.32 2.39 1.47.3.15.47.12.65-.07.17-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.28.1 1.75.83 2.05.98.3.15.5.22.57.35.08.12.08.72-.17 1.42Z" /></svg>
        </a>
        <a href={CONTACT.phoneHref} className="fc-round fc-round--call" aria-label={`Call ${CONTACT.phone}`}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" /></svg>
        </a>
        <Link to="/contact" className="fc-pill">Free Consultation <span aria-hidden="true">→</span></Link>
      </div>

      <nav className="fc-mobile" aria-label="Quick contact">
        <a href={CONTACT.phoneHref}><Icon name="phone" size={16} /> Call</a>
        <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer"><Icon name="chat" size={16} /> WhatsApp</a>
        <Link to="/contact" className="fc-mobile__cta">Free Quote</Link>
      </nav>
    </>
  );
}

export default FloatingContact;
